import { render, staticRenderFns } from "./waterfall.vue?vue&type=template&id=6d9c3cb6&"
import script from "./waterfall.vue?vue&type=script&lang=js&"
export * from "./waterfall.vue?vue&type=script&lang=js&"
import style0 from "./waterfall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports